import type { Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { isWatermarkAsset } from 'js/src/agent/video-state/serialization/mediaHelpers';

/**
 * Whether the scene's graphic is layered over other content — footage, a speaker, a stock design —
 * rather than owning the frame. Derived from what the scene holds rather than stored, so a graphic
 * is judged the same however it is reopened: by a later edit, a copy, an undo, or the design pane.
 *
 * A watermark and stickers sit on top of whatever the scene shows, so they are not content the
 * graphic is laid over.
 */
export function isLayeredGraphicScene(scene: Scene): boolean {
    const graphics = new Set<unknown>(scene.getAssetsByType(VideoData.HTML_ASSET_TYPE));
    if (graphics.size === 0) {
        return false;
    }
    return scene
        .getAssets()
        .some(
            (asset) =>
                !graphics.has(asset) &&
                !isWatermarkAsset(asset) &&
                !VideoData.isStickerAsset(asset),
        );
}
